import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {User} from '../define';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  public user$: Observable<User>;
  private userSubject: BehaviorSubject<User>;
  private pathPermissions = {};

  constructor(private api: ApiService) {
    this.userSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('user')));
    this.user$ = this.userSubject.asObservable();
  }

  public get user(): User {
    return this.userSubject.value;
  }

  public login(id: string, password: string, remember: boolean, OnLogin: (success: boolean, message: string) => void): void {
    this.api.login(id, password, remember, ((success, message, user) => {

      if (success) {
        localStorage.setItem('user', JSON.stringify(user));
        this.userSubject.next(user);
        OnLogin(true, null);
      } else {
        OnLogin(false, message);
      }
    }));
  }

  public logout(): void {
    this.api.logout();
    localStorage.removeItem('user');
    this.userSubject.next(null);
  }

  public isRole(role: string): boolean {
    return this.user && Array.isArray(this.user.roles) && this.user.roles.includes(role);
  }

  public getRoles(): string[] {
    if (!this.user || !Array.isArray(this.user.roles)) {
      return null;
    }
    return this.user.roles;
  }

  /**
   * Return null: all of right.
   * Return []: no right
   * @param path checked api path
   */
  public getPathPermissions(path): any {
    if (!this.user || !Array.isArray(this.user.roles)) {
      return null;
    }

    if (Object.keys(this.pathPermissions).includes(path)) {
      return this.pathPermissions[path];
    }

    // Get module by path
    const modules = [];
    Object.entries(this.user.api_path).forEach(
      ([key, value]) => {
        if (path.indexOf(value) >= 0) {
          if (this.user.api_module[key]) {
            this.user.api_module[key].forEach(moduleCode => {
              if (!modules.includes(moduleCode)) {
                modules.push(moduleCode);
              }
            });
          }
        }
      }
    );

    if (modules.length === 0) {
      this.pathPermissions[path] = null;
    }else{
      const permissions = [];
      modules.forEach(moduleCode => {
        if (this.user.module_permission[moduleCode]) {
          this.user.module_permission[moduleCode].forEach(permission => {
            if (!permissions.includes(permission)) {
              permissions.push(permission);
            }
          });
        }
      });
      this.pathPermissions[path] = permissions;
    }

    return this.pathPermissions[path];
  }

  public isPathPermission(path, permission): boolean {
    const permissions = this.getPathPermissions(path);
    if (permissions == null) {
      return true;
    }
    return permissions.includes(permission);
  }

  public getModulePermissions(moduleCode): any {
    if (!this.user || !Array.isArray(this.user.roles)) {
      return null;
    }

    if (this.user.module_permission[moduleCode]) {
      const permissions = [];
      this.user.module_permission[moduleCode].forEach(permission => {
        if (!permissions.includes(permission)) {
          permissions.push(permission);
        }
      });
      return permissions;
    }else{
      return null;
    }
  }

  public isModulePermission(moduleCode, permission): boolean {
    const permissions = this.getModulePermissions(moduleCode);
    if (permissions == null) {
      return true;
    }
    return permissions.includes(permission);
  }
}
